import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux"; //useDispatch
import ItemService from "../../../../../services/supplier_appCommonService";
import Layout from "../../../../../Layout/Layout";
import Constants from "../../../../../common/CustomerConstants";
import CommonItemLevelDatatableModal from "../../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import {
  addcustomerID,
  getCustomerList,
  workflow,
} from "../../../../../redux/feature/customer_app/customerSlice";
// import CommonFillter from "../../../../Components/Filter/Supplier/SupplierCommonFillter";
import ShowStatus from "../../../../../Components/Modal/supplier_app/Workflow/ShowStatus";
import {
  formatDate,
  formatDateWithAMPM,
  getContactDetails,
} from "../../../../../common/Validations";
import { SearchField } from "../../../../../Components/formElements/SearchField";
import SuccessModal from "../../../../../Components/Modal/supplier_app/SuccessModal";
import CreateInviteSupplierModal from "../../../../../Components/Modal/supplier_app/CreateInviteSupplierModal";
import ConfirmSendInvitationModel from "../../../../../Components/Modal/supplier_app/ConfirmSendInvitationModel";
import ConfirmationLoader from "../../../../../Components/ConfirmationLoader";
import { TableStatusField } from "../../../../../Components/formElements/TableStatusField";
import { formatDateTime } from "../../../../../common/Validations";
import StickyColumn from "../../../../../Components/Sticky/StickyColumn";
import SupplierDeactivateModel from "../../../../../Components/Modal/supplier_app/SupplierDeactivateModel";
import CreateCustomerMasterModal from "../../../../../Components/Modal/customer_app/CreateCustomerMasterModal";
import BroadcastModel from "../../../../../Components/Modal/supplier_app/BroadcastModel";
import CommonFilterCustomerV2 from "../../../../customer_app/Customer_V2/Common/CommonFilterCustomerV2";
const GodownMasterList = () => {
  // eslint-disable-next-line no-unused-vars
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Customer");
  localStorage.setItem("submenu", "Customer Master");
  let customerData = useSelector((state) => state?.customer); // User Details from Store
  let customerTable = useSelector((state) => state?.customer.pagination); // User Details from Store
  let config = useSelector((state) => state?.common?.data?.suppliers); // User Details from Store

  //Page Config
  let pageConfig = useSelector((state) => state?.common?.data?.pageConfig); // Config Details from Store
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  // eslint-disable-next-line
  const [pageConfigInfo, setPageConfigInfo] = useState(null);
  // eslint-disable-next-line
  const [userRole, setUserRole] = useState(null);

  useEffect(() => {
    const getRole = userData?.roles?.[0]?.roleId || null;
    setUserRole(getRole);
    setPageConfigInfo(pageConfig);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageConfig, userData]);

  const [data, setData] = useState([]);
  // const [loading, setLoading] = useState(false);
  // const [totalRows, setTotalRows] = useState(10);
  const [isCardVisible, setCardVisible] = useState(true);
  const [modalShow, setModalShow] = useState(false);
  const [modalShowStatus, setModalShowStatus] = useState(false);
  const [sendDataModal /* setSendDataModal */] = useState("");
  const [modelTitle /* setModelTitle */] = useState("");

  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  const [getAccountGroup, setAccountGroup] = useState([]);
  const [getNewPerPage, setNewPerPage] = useState(10);
  const [getCommonSearchTxt, setCommonSearchTxt] = useState("");

  const [isPageLoading, setIsPageLoading] = useState(false); // Loading state
  const [selectedRows, setSelectedRows] = useState([]);
  /* pop success modal */
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const successModalData = {
    title: "Success",
    successMsg: "",
  };
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getShowSupplierInviteModal, setShowSupplierInviteModal] =
    useState(false);
  const [getShowSendInvitationModal, setShowSendInvitationModal] =
    useState(false);
  const [getShowhideBroadcastModel, setShowhideBroadcastModel] =
    useState(false);
  const [getShowSupplierDeactivateModel, setShowSupplierDeactivateModel] =
    useState(false);
  const [filterShow, setFilterShow] = useState(false);

  const [getFilter, setFilter] = useState({});

  const onSuccessmodel = () => setShowSuccessModal(true);
  const hideSuccessModal = () => setShowSuccessModal(false);
  const hideSupplierInviteModal = () => setShowSupplierInviteModal(false);
  const hideSendInvitationModal = () => setShowSendInvitationModal(false);
  const hideBroadcastModel = () => setShowhideBroadcastModel(false);
  const hideSupplierDeactivateModel = () =>
    setShowSupplierDeactivateModel(false);
  const handleRowSelect = ({ selectedRows }) => {
    setSelectedRows(selectedRows);
  };

  // Chat Implementation
  const [chatId, setChatId] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const toggleChat = (groupId) => {
    // Toggle the same PR closes the chat
    if (chatId === groupId) {
      setChatId(null);
    } else {
      setChatId(groupId);
    }
  };
  const sendInvitation = async () => {
    if (selectedRows.length === 0) {
      // alert("Please select at least one row.")
      successModalData.title = "Error";
      successModalData.successMsg = "Please select at least one row.";
      setsucceModalData(successModalData);
      onSuccessmodel();
      return;
    }
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
      };
      // console.log("obj", obj);
      await ItemService.sendInvitation(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleBroadcast = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const emailIds = selectedRows.map((row) => row.email);
      let obj = {
        email: emailIds,
        broadcastRemark: payload?.broadcastRemark,
      };
      // console.log("obj", obj);
      await ItemService.supplierBroadcast(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to Broadcast:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const handleDeactivateSupplier = async (payload) => {
    try {
      setIsPageLoading(true); // Start loading
      const supplierIds = selectedRows.map((row) => row.userId);
      let obj = {
        supplierIds: supplierIds,
        remark: payload?.remark,
      };
      // console.log("obj", obj);
      await ItemService.supplierDeactivate(obj).then((item) => {
        // console.log(">> item!", item);
        if (item?.status === 200) {
          successModalData.successMsg = item?.message;
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
        }
      });
    } catch (error) {
      console.log("Failed to De-activate:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const inviteSupplier = async (formData) => {
    setIsPageLoading(true); // Start loading
    try {
      await ItemService.inviteSupplier(formData).then((item) => {
        if (item?.status === 200) {
          console.log("item", item);
          successModalData.successMsg = item?.message;
          setShowSuccessModal(true);
          setsucceModalData(successModalData);
          onSuccessmodel();
        } else {
          console.error("Failed to send invitation:");
        }
      });
    } catch (error) {
      console.log("Failed to send invitaion:", error);
    } finally {
      setIsPageLoading(false); // End loading
    }
  };
  const detailedPage = (customerID) => {
    dispatch(addcustomerID(customerID));
    navigate(Constants.CUSTOMER_V2_REGISTER_DETAIL);
  };
  //required in feature
  // const navigateConvertKYC = (customerID) => {
  //   dispatch(addcustomerID(customerID));
  //   navigate(Constants.CUSTOMER_V1_KYC_REGISTRATION_FORM);
  // };
  //required in feature
  // const navigateCostingSheet = (customerID) => {
  //   dispatch(addcustomerID(customerID));
  //   navigate(Constants.CUSTOMER_V1_COSTING_SHEET);
  // };

  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };
  // OnClick on categoryItem  Data
  // eslint-disable-next-line no-unused-vars
  const showProjectDetailsModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(projectColModal);
    setModalTitle("Project Details");
    setItemLevelModalShow(true);
  };

  // OnClick on Certificate document Data
  const certificateDocumentShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(certificateDocumentColInfo);
    setModalTitle("Certificate document Details");
    setItemLevelModalShow(true);
  };

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  /* Modal Function */

  const hideModal = () => {
    setModalShow(false);
  };

  const loadInitialSuuplierData = async () => {
    setData(customerData?.data);
  };

  const handlePageChange = (page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "getCustomerListV1",
        module: "CUSTOMER_KYC",
        page: page,
        per_page: getNewPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "getCustomerListV1",
        module: "CUSTOMER_KYC",
        page: page,
        per_page: getNewPerPage,
      };
    }
    // let obj = {
    //   queryName: "getCustomerListV1",
    //   module: "CUSTOMER_KYC",
    //   page: page,
    //   per_page: getNewPerPage,
    // };

    dispatch(getCustomerList(obj));
    setData(customerData?.data);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    let obj = {};
    const filterCheck = Object.keys(getFilter);
    if (filterCheck.length > 0) {
      obj = {
        queryName: "getCustomerListV1",
        module: "CUSTOMER_KYC",
        page: page,
        per_page: newPerPage,
        rowFilter: {
          $and: [getFilter],
        },
      };
    } else {
      obj = {
        queryName: "getCustomerListV1",
        module: "CUSTOMER_KYC",
        page: page,
        per_page: newPerPage,
      };
    }

    setNewPerPage(newPerPage);
    dispatch(getCustomerList(obj));
    setData(customerData?.data);
  };

  // Common Search Function on button
  const handleSearchFuncApi = async () => {
    let obj = {
      queryName: "getCustomerListV1",
      module: "CUSTOMER_KYC",
      page: 1,
      per_page: 10,
      searchTerm: getCommonSearchTxt,
    };
    dispatch(getCustomerList(obj));
  };

  useEffect(() => {
    const fetchData = async () => {
      await loadInitialSuuplierData();
      dispatch(workflow({}));
    };

    fetchData();

    // loadInitialSuuplierData(); // fetch page 1 of users
    // dispatch(workflow({}));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerData?.data]);

  //on page load
  useEffect(() => {
    dispatch(addcustomerID(""));
    let obj = {
      queryName: "getCustomerListV1",
      module: "CUSTOMER_KYC",
      page: 1,
      per_page: 10,
    };
    dispatch(getCustomerList(obj));
    getMasterData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  // Example: assuming your table data is stored in state

  // When you fetch data from API:
  // useEffect(() => {
  //   // Example: assuming fetchCustomers() returns the API data
  //   fetchCustomers().then((res) => {
  //     setTableData(res);
  //   });
  // }, []);

  const columns = [
    // {
    //   name: "Profile",
    //   width: "80px",
    //   cell: (row) => (
    //     <img
    //       src="assets/img/profile-img.png"
    //       alt="Profile"
    //       className="rounded-circle profileImageCss"
    //       style={{ width: "40px" }}
    //     />
    //   ),
    // },
    {
      name: "Customer ID",
      id: "userId",
      selector: (row) => row.userId || "--",
      sortable: true,
      cell: (row) => (
        <button className="btnInfo" onClick={() => detailedPage(row.userId)}>
          {row.userId || "-"}{" "}
        </button>
      ),
      width: "130px",
    },
    {
      name: "Customer",
      id: "organisationName",
      cell: (row) => (
        <>
          <span className="m-0 p-0 pt-1 fw-bold text-primary">
            {row.organisationName}
          </span>
        </>
      ),
      selector: (row) => row.organisationName,
      sortable: true,
      width: "150px",
    },

    {
      name: "Address",
      selector: (row) => row.address || "--",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.address} </p>
          <p className="m-0 p-0 fw-bold">{row.address2} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    {
      name: "Company",
      id: "companyCodeDesc",
      selector: (row) => row.companyCode,
      cell: (row) => (
        <>
          <span className="fw-bold text-success">{row.companyCodeDesc}</span>
        </>
      ),
      sortable: true,
      width: "140px",
    },
    {
      name: "Ship-to-Party",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => showProjectDetailsModal(row.projectDetails)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">{row.projectDetails?.length}</span>
        </>
      ),
      width: "130px",
    },
    // {//Add Chat Option here
    //   name: "Chat",
    //   cell: (row) => (
    //     <>
    //       <button
    //         onClick={() => toggleChat(row.userId)}
    //         className={`flex items-center gap-1 ${
    //           chatId === row.userId ? "text-green-600" : "text-blue-600"
    //         } hover:text-blue-800`}
    //       >
    //         <MessageCircle className="w-5 h-5" />
    //         Chat
    //       </button>
    //     </>
    //   ),
    //   width: "130px",
    // },
    {
      name: " Sales Person",
      id:"salesOfficerName",
      selector: (row) => row.salesOfficerName || "--",

      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold ">{row.salesOfficerName} </p>
          <p className="m-0 p-0 ">{row.salesOfficerCode} </p>
        </div>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "SAP Number",
    //   selector: (row) => row.sapAssociateNumber || "--",
    //   sortable: true,
    //   width: "150px",
    // },
    /*   {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    }, */

    // {
    //   name: "Costing Sheet",
    //   cell: (row) => (
    //     <>
    //       <button
    //         className="btnTable"
    //         onClick={() => navigateCostingSheet(row.userId)}
    //       >
    //         Genrate {row.publish}
    //       </button>
    //     </>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "KYC",
    //   cell: (row) => (
    //     <>
    //       {row.KYCIndicator && row.KYCIndicator === "KYC" ? (
    //         <button className="btnTable" disabled={true}>
    //           Update
    //         </button>
    //       ) : (
    //         <button
    //           className="btnTable"
    //           onClick={() => navigateConvertKYC(row.userId)}
    //         >
    //           Update
    //         </button>
    //       )}
    //     </>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "KYC Workflow",
    //   selector: (row) => row.workflowActionLogs,
    //   cell: (row) => (
    //     <div
    //       style={{ width: "100%" }}
    //       className="d-flex justify-content-center iconTable"
    //     >
    //       <img
    //         src="assets/img/newIcons/workflow.png"
    //         alt="attachments"
    //         style={{ width: "35px" }}
    //         className="mt-1"
    //         onClick={() => showStatusInfo(row.workflowActionLogs)}
    //       />
    //     </div>
    //   ),
    //   sortable: true,
    //   width: "142px",
    // },
    {
      name: "Documents",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => certificateDocumentShowModal(row.certifications)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">{row.certifications?.length}</span>
        </>
      ),
      width: "130px",
    },
    {
      name: "Status",
      cell: (row) => (
        <TableStatusField status={row.activeInactive ? "Active" : "Inactive"} />
      ),
      width: "130px",
    },

    {
      name: "Contact Person",
      cell: (row) => (
        <>
          <span>{getContactDetails(row)?.contactName}</span>
        </>
      ),
      // selector: (row) => row.contactfirstName || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Number/Email",
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-medium">
              {getContactDetails(row)?.contactNumber}
            </p>
            <p className="m-0 p-0">{getContactDetails(row)?.contactEmail}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "150px",
    },
    // {
    //   name: "Contact Email",
    //   cell: (row) => (
    //     <>
    //       <span>{getContactDetails(row)?.contactEmail}</span>
    //     </>
    //   ),
    //   // selector: (row) => row.email,
    //   sortable: true,
    //   width: "220px",
    // },
    /*   {
      name: "Deactivate Remark",
      cell: (row) => (
        <>
          <span>{row?.remark}</span>
        </>
      ),
      // selector: (row) => row.email,
      sortable: true,
      width: "220px",
    }, */
    {
      name: "Created  By/Date",
      id:"createdAt",
      selector: (row) => formatDateTime(row.createdAt),
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 fw-medium">{row?.createdBy}</p>
            {/* <p className="m-0 p-0">{formatDateTime(row?.createdAt)}</p> */}
            <p className="m-0 p-0">{formatDateWithAMPM(row?.createdAt)}</p>
          </div>
        </>
      ),
      sortable: true,
      width: "160px",
    },
    // {
    //   name: "Company",
    //   cell: (row) => (
    //     <>
    //       <span> {row.companyCode} </span>
    //     </>
    //   ),
    //   width: "150px",
    // },
    // {
    //   name: "Block Reason",
    //   selector: (row) => row.rfqTechFocalPerson,
    //   sortable: true,
    //   width: "130px",
    // },
    // {
    //   name: "SAP Remark",
    //   selector: (row) => row.rfqTechTargetDate,
    //   sortable: true,
    //   width: "140px",
    // },
    // {
    //   name: "SAP Error Msg",
    //   selector: (row) => row.extensionCount,
    //   sortable: true,
    //   width: "140px",
    // },

    // {
    //   name: "SAP Reprocess",
    //   cell: (row) => (
    //     <>
    //       <button className="btnTable">Reprocess {row.publish}</button>
    //     </>
    //   ),
    //   width: "140px",
    // },
  ];

  const projectColModal = [
    {
      name: "Project Code",
      cell: (row) => <span>{row.projectCode} </span>,
      width: "180px",
    },
    {
      name: "Project Name",
      cell: (row) => <span>{row.projectName} </span>,
      width: "180px",
    },
    {
      name: "Project Location",
      cell: (row) => (
        <span>
          {row.getLocations?.length > 0
            ? row.getLocations[0]?.projectLocation
            : ""}
        </span>
      ),
      width: "180px",
    },
    {
      name: "Project State",
      cell: (row) => <span>{row.projectState} </span>,
      width: "180px",
    },
    {
      name: "Project Country",
      cell: (row) => <span>{row.projectCountry} </span>,
      width: "180px",
    },
  ];

  const certificateDocumentColInfo = [
    {
      name: "Certificate Type",
      cell: (row) => <span>{row.documentType} </span>,
      width: "180px",
    },
    {
      name: "Certificate Number",
      cell: (row) => <span>{row.documentNumber} </span>,
      width: "180px",
    },
    {
      name: "Issuing  Date",
      cell: (row) => <span>{formatDate(row.issueDate)} </span>,
      width: "180px",
    },
  ];

  const getMasterData = async () => {
    let obj = {
      codeType: "accountGroup",
    };
    await ItemService.getMasterData(obj).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setAccountGroup(item?.data);
      } else {
        setAccountGroup([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
  };

  /* Modal Function */
  /* required  */
  // const showStatusInfo = (rowData) => {
  //   setModalShowStatus(true);
  //   setSendDataModal(rowData);
  //   setModelTitle("Status Information");
  // };

  const hideModalStatus = () => {
    setModalShowStatus(false);
  };
  const [getUserRoles, setUserRoles] = useState();
  // console.log(">>getUserRoles",getUserRoles)
  useEffect(() => {
    if (userData?.roles) {
      const allowedRoles = ["SALES-ADMIN"];
      const isAllowed = userData.roles.some((r) =>
        allowedRoles.includes(r.roleId),
      );
      setUserRoles(isAllowed);
    }
  }, [userData]);

  const handleCustomerRegister = () => {
    if (getUserRoles) {
      navigate(Constants.CUSTOMER_V2_REGISTER);
    } else {
      navigate(Constants.CUSTOMER_V2_REGISTER_BY_SALES_OFFICER);
    }
  };
  const handleAdvanceSearchFuncApi = async (filters) => {
    let obj = {
      queryName: "getCustomerListV1",
      module: "CUSTOMER_KYC",
      page: 1,
      per_page: 10,
      searchTerm: "",
      rowFilter: {
        $and: [filters],
      },
    };
    setFilter(filters);
    dispatch(getCustomerList(obj));
  };

  return (
    <main className="dashboard main" id="main">
      {/* Spinner Overlay */}
      <ConfirmationLoader isPageLoading={isPageLoading} />
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={12} md={8} lg={8}>
                <h2 className="mainTitle">Customer List</h2>
                <p className="subText">Customer Directory and Overview </p>
              </Col>
              <Col xs={12} md={3} lg={3} className="mt-3">
                <SearchField
                  name="searchKey"
                  value={getCommonSearchTxt}
                  onChange={(event) => setCommonSearchTxt(event.target.value)}
                  onClick={() => handleSearchFuncApi()}
                />
              </Col>
              <Col xs={4} md={1} lg={1}>
                <span
                  className="filterIcon"
                  onClick={() => setFilterShow(!filterShow)}
                >
                  <i className="bi bi-filter"></i>
                </span>
              </Col>
            </Row>
            <hr />
            <Row>
              <Col xs={12} md={12} lg={12}>
                {filterShow && (
                  <CommonFilterCustomerV2
                    getfiltereddata={columns}
                    cancelAction={() => setFilterShow(!filterShow)}
                    onSubmit={(filters) => {
                      // console.log(">>Received filters from child:", filters);
                      // const filterData=[filters]
                      handleAdvanceSearchFuncApi(filters);
                      // You can now use the filters here
                    }}
                  />
                )}
              </Col>
            </Row>

            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CL</span>
                    </Col>
                    <Col xs={8} md={3} lg={3}>
                      <span className="headerTitle">Customer List</span>
                      <span className="subHeaderTitle">
                        View of Customers and Status{" "}
                      </span>
                    </Col>

                    <Col xs={12} md={7} lg={7} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        <button
                          className="btnTable"
                          onClick={handleCustomerRegister}
                        >
                          <i className="bi bi-person-plus"></i> Add Customer
                        </button>
                      </Col>
                      {/* deative button required */}
                      {/* {hasAccess(
                        userRole,
                        "buttons",
                        "customer_list_add_deactivate",
                        pageConfigInfo
                      ) &&
                        config?.deactivateListBtn && (
                          <Col
                            xs={4}
                            md={2}
                            lg={2}
                            className="btnSpaceInMobile"
                          >
                            <button
                              className="btnTable"
                              onClick={() =>
                                setShowSupplierDeactivateModel(true)
                              }
                            >
                              Deactivate List
                            </button>
                          </Col>
                        )} */}

                      {config?.filter && (
                        <Col xs={2} md={1} lg={1} className="">
                          <>
                            <div className="filter">
                              <span
                                className="icon hide headerIcon"
                                data-bs-toggle="dropdown"
                                aria-expanded="true"
                              >
                                <i className="bi bi-three-dots"></i>
                              </span>
                              <ul
                                className="dropdown-menu dropdown-menu-end dropdown-menu-arrow hide menuList"
                                data-popper-placement="bottom-end"
                              >
                                <li className="dropdown-header text-start">
                                  <h6>Menu</h6>
                                </li>

                                <li>
                                  <span
                                    className="dropdown-item headerIcon"
                                    onClick={() => handleSearchFuncApi()}
                                  >
                                    <i className="bi bi-arrow-clockwise"></i>
                                    Refresh Data
                                  </span>
                                </li>
                              </ul>
                            </div>
                          </>
                        </Col>
                      )}
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                  // aria-labelledby="headingOne"
                  // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <Row>
                      <StickyColumn
                        columnIndexes={[2, 3, 4]}
                        leftOffsets={[0, 120, 230]}
                      />
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={columns}
                          data={data}
                          progressPending={customerData?.status}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          paginationServer
                          paginationTotalRows={customerTable.total}
                          onChangeRowsPerPage={handlePerRowsChange}
                          onChangePage={handlePageChange}
                          onSelectedRowsChange={handleRowSelect}
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <CreateCustomerMasterModal
        show={modalShow}
        onHide={() => hideModal()}
        dropdownData={getAccountGroup}
      />

      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      <ShowStatus
        show={modalShowStatus}
        onHide={() => hideModalStatus()}
        rowdatamodal={sendDataModal}
        modeltitle={modelTitle}
      />
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
      />
      <CreateInviteSupplierModal
        show={getShowSupplierInviteModal}
        onHide={hideSupplierInviteModal}
        onSubmit={inviteSupplier}
      />
      <ConfirmSendInvitationModel
        show={getShowSendInvitationModal}
        onHide={hideSendInvitationModal}
        onSubmit={sendInvitation}
        selectedRows={selectedRows}
      />
      <BroadcastModel
        show={getShowhideBroadcastModel}
        onHide={hideBroadcastModel}
        onSubmit={handleBroadcast}
        selectedRows={selectedRows}
      />
      <SupplierDeactivateModel
        show={getShowSupplierDeactivateModel}
        onHide={hideSupplierDeactivateModel}
        onSubmit={handleDeactivateSupplier}
        selectedRows={selectedRows}
      />
      {/* {chatId && (
        <ChatBox
          groupId={chatId}
          chatTitle="User"
          onClose={() => setChatId(null)}
        />
      )} */}
    </main>
  );
};

export default GodownMasterList;
